<template>
  <transition-fade :duration="500" appear expand>
    <div v-if="items.length" id="facets-in-use" class="w-full">
      <div class="wrap mt-[-1vh] pb-[30px]">
        Resultaat verfijnd op:

        <transition-group name="list-facets-applied" tag="div" class="contents">
          <router-link
            v-for="facet in items"
            :key="facet.key"
            :to="facet.route"
            class="facet-link rounded-full rounded-bl-none btn btn-circle before:content-['×_'] before:font-black first:ml-[.4vw]"
            :class="computedSchoolLevelRouterLinkClass"
          >
            <slot :name="facet.type" :item="facet.item" />
          </router-link>
          <router-link-button
            key="remove-all"
            :to="{
              ...$route,
              query: {
                zoek: query,
              },
            }"
            variant="removeAll"
          >
            Verwijder alle filters
          </router-link-button>
        </transition-group>
      </div>
    </div>
  </transition-fade>
</template>

<script>
import RouterLinkButton from "../RouterLinkButton.vue";
import TransitionFade from "../../magic/TransitionFade.vue";

import { mapGetters } from "vuex";

export default {
  name: "MediaArchiveFacetsApplied",
  components: {
    RouterLinkButton,
    TransitionFade,
  },
  computed: {
    ...mapGetters(["activeSeasonContentForSchoolLevel"]),

    computedSchoolLevelRouterLinkClass() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      if (!slug) return "";

      const bgMap = {
        onderbouw: "bg-yellow-200 hover:bg-yellow",
        "midden-bovenbouw": "bg-yellowGreen-200 hover:bg-yellowGreen",
      };

      return bgMap[slug] || "";
    },
  },
  props: {
    items: {
      type: Array,
    },
    query: {
      type: String,
    },
  },
};
</script>

<style scoped lang="css">
/* Transitions */

.list-facets-applied-enter-active,
.list-facets-applied-leave-active {
  opacity: 1;
  transition: opacity 300ms ease;
}

.list-facets-applied-move {
  transition: transform 0.3s ease;
}

.list-facets-applied-enter-from,
.list-facets-applied-leave-to {
  opacity: 0;
}

.list-facets-applied-leave-active {
  position: absolute;
  transition-duration: 200ms;
}
</style>
